import { useState } from "react";
import { AuthLayout } from "../layouts/AuthLayout";
import { ForgotPasswordModal } from "../components/ForgotPasswordModal";
import "./LoginPage.css";

type LoginPageProps = {
  onSubmit?: (email: string, password: string) => Promise<void> | void;
  sessionExpired?: boolean;
};

export function LoginPage({ onSubmit, sessionExpired }: LoginPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [forgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);

  return (
    <AuthLayout>
      <div className="login-page">
        <div className="login-header">
          <div className="login-brand">XLFlow</div>
          <h1>Connexion</h1>
          <p>Accédez à votre espace sécurisé.</p>
        </div>

        {sessionExpired && (
          <div className="login-session-expired" role="alert">
            Votre session a expiré. Veuillez vous reconnecter.
          </div>
        )}

        <form
          className="login-form"
          onSubmit={async (event) => {
            event.preventDefault();
            setErrorMessage("");
            setIsSubmitting(true);
            try {
              await onSubmit?.(email.trim(), password);
            } catch (error) {
              setErrorMessage((error as Error).message || "Échec de connexion");
            } finally {
              setIsSubmitting(false);
            }
          }}
        >
          <label className="login-field">
            Email
            <input
              type="email"
              placeholder="prenom.nom@entreprise.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
            />
          </label>

          <label className="login-field">
            Mot de passe
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
              >
                {showPassword ? "Masquer" : "Afficher"}
              </button>
            </div>
          </label>

          <div className="login-actions">
            <button
              type="button"
              className="login-link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setForgotPasswordModalOpen(true);
              }}
            >
              Mot de passe oublié
            </button>
          </div>

          {errorMessage ? <p className="text-xs text-danger">{errorMessage}</p> : null}

          <button type="submit" className="login-primary" disabled={isSubmitting}>
            {isSubmitting ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
      <ForgotPasswordModal
        open={forgotPasswordModalOpen}
        onClose={() => setForgotPasswordModalOpen(false)}
      />
    </AuthLayout>
  );
}
